import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import GridModal from '../../Components/Modal_Grid';
import BasicButton from '../../Components/Button_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function MM10010(props) {
    React.useEffect(() => {
        document.title = '생산계획등록';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '생산관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>생산계획등록</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    const today1 = new Date();
    const newDay1 = new Date();
    const [itemModalToggle, setItemModalToggle] = React.useState(false);
    //품목 리스트 팝업
    const itemModalColumnDef = [
        {
            field: 'plantCd',
            headerName: '사업장 코드',
            hide: true,
        },
        {
            field: 'itemCd',
            headerName: '품목 코드',
            checkboxSelection: true,
        },
        { field: 'itemNm', headerName: '품목 명', minWidth: 300 },
        { field: 'itemStd', headerName: '규격' },
    ];

    const onCellClicked = (e) => {
        let selected = e.data;
        props.setInputs({
            ...props.inputs,
            plantCd: selected.plantCd,
        });
    };

    return (
        <div>
            <div>
                <div style={{ height: '50%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {/* <h1 style={{ width: "120px", marginRight: "5px" }}>
                생산계획등록
              </h1> */}
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginRight: '5px' }}
                                selected={props.inputs.startDate}
                                onChange={(e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        startDate: e,
                                    });
                                }}
                                disabled={true}
                                startDate={props.inputs.startDate}
                            />
                            <DatePicker
                                className={'datepicker-custom-input'}
                                style={{ width: '120px', marginLeft: '5px' }}
                                selected={props.inputs.endDate}
                                onChange={(e) => {
                                    props.setInputs({
                                        ...props.inputs,
                                        endDate: e,
                                    });
                                    props.Init(e);
                                }}
                                startDate={props.inputs.startDate}
                                endDate={props.inputs.endDate}
                                minDate={props.inputs.startDate}
                                maxDate={new Date(newDay1.setDate(today1.getDate() + 7))}
                            />
                        </div>
                        {/* 상단 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="MM10010"
                            target="G01"
                            refreshNone="none"
                            selectFunc={() => props.Init()}
                            addFunc={() => {
                                setItemModalToggle(true);
                            }}
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '335px' }}>
                        {/* 상단 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={props.columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 120,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
                            }
                            onCellClicked={onCellClicked}
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '370px' }}>
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <h1 style={{ width: '150px', marginRight: '5px' }}>자재 소요 예측 현황</h1>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <BasicButton name="계산" onClick={(e) => props.CalcularConfirm()} />
                            {/* 하단 그리드 버튼 */}
                            <AuthGroupButton
                                pageName="MM10010"
                                target="G02"
                                refreshNone="none"
                                refreshFunc={() => {
                                    props.Init();
                                }}
                                addFunc={() => props.setModalToggle(true)}
                                saveFunc={() => props.SaveConfirm()}
                                deleteFunc={() => props.DeleteConfirm()}
                            />
                        </div>
                    </Card>
                    {/* 하단 그리드 */}
                    <AgGridReact
                        ref={gridRef1}
                        animateRows={true}
                        columnDefs={props.columnDefs1}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 120,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        rowData={props.rowData1}
                        rowSelection="single"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)}
                    />
                </div>
            </div>
            {/* 품목 리스트 팝업 */}
            {itemModalToggle && (
                <GridModal
                    name="품목 리스트"
                    onClose={() => setItemModalToggle(false)}
                    gridColumn={itemModalColumnDef}
                    gridRowData={props.itemRowData}
                    buttonName1="확인"
                    gridRowSelection={'single'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push(e[i]);
                        }
                        props.setSelectedItemRowData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        props.setInputs({
                            ...props.inputs,
                            plantCd: props.selectedItemRowData[0].plantCd,
                        });
                        gridRef.current.api.setRowData([
                            {
                                plantCd: props.selectedItemRowData[0].plantCd,
                                itemCd: props.selectedItemRowData[0].itemCd,
                                itemNm: props.selectedItemRowData[0].itemNm,
                                itemStd1: props.selectedItemRowData[0].itemStd,
                            },
                            ...props.rowData,
                        ]);
                    }}
                />
            )}
        </div>
    );
}

export default MM10010;
